var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWebsiteLinkedin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 13,
    viewBox: "0 0 14 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group 45588"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M0.845703 2.27176C0.845703 1.87708 0.984307 1.55148 1.2615 1.29496C1.5387 1.03842 1.89907 0.910156 2.34258 0.910156C2.77819 0.910156 3.13062 1.03644 3.39991 1.28904C3.6771 1.54952 3.81571 1.88892 3.81571 2.30728C3.81571 2.68616 3.68107 3.00188 3.41179 3.25448C3.13459 3.51496 2.77027 3.6452 2.31882 3.6452H2.30694C1.87134 3.6452 1.51891 3.51496 1.24962 3.25448C0.980339 2.994 0.845703 2.66642 0.845703 2.27176ZM1.00014 12.6318V4.72264H3.63751V12.6318H1.00014ZM5.09875 12.6318H7.73611V8.21544C7.73611 7.93917 7.76779 7.72605 7.83115 7.57608C7.94203 7.30771 8.11033 7.08077 8.33605 6.89528C8.56177 6.70978 8.84491 6.61704 9.18547 6.61704C10.0725 6.61704 10.516 7.21299 10.516 8.40488V12.6318H13.1534V8.09704C13.1534 6.92883 12.8762 6.0428 12.3218 5.43896C11.7674 4.83512 11.0348 4.5332 10.124 4.5332C9.10231 4.5332 8.30635 4.97128 7.73611 5.84744V5.87112H7.72423L7.73611 5.84744V4.72264H5.09875C5.11458 4.97522 5.12251 5.76061 5.12251 7.0788C5.12251 8.39699 5.11458 10.248 5.09875 12.6318Z",
    fill: "#4B4AD5"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWebsiteLinkedin);
export default __webpack_public_path__ + "static/media/website-linkedin.6cc1f39694ce46bd72b4bf6e04289be1.svg";
export { ForwardRef as ReactComponent };